
import Vue from "vue";

export default Vue.extend<{}, Methods, {}, Props>({
  props: {
    onClickOutside: {
      type: Function,
      required: true,
    },
  },

  methods: {
    handleClickOutside() {
      this.onClickOutside();
    },
  },

  mounted() {
    // 背景のスクロールを無効化
    document.body.style.overflow = "hidden";
  },

  beforeDestroy() {
    // 背景のスクロールを有効化
    document.body.style.overflow = "";
  },
});

interface Methods {
  handleClickOutside: () => void;
}

interface Props {
  onClickOutside: () => void;
}
